import React from "react";
import { format, addDays } from "date-fns";

const DisplayInfoEleve = ({ d, ph }) => {
  const formatDateNaiss = (dateStr) => {
    if (!dateStr || dateStr.length < 8) return "N/A";
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    const day = dateStr.substring(6, 8);
    const parsedDate = new Date(`${year}-${month}-${day}`);
    return format(addDays(parsedDate, 1), "dd/MM/yyyy");
  };

  return (
    <div className="container my-3">
      <h4 className="text-center display-5 mb-3">
        {d?.NOMEL} {d?.PRENOMEL}{" "}
        {d?.DNAISS ? `né(e) le : ${formatDateNaiss(d.DNAISS)}` : ""}
        {!ph && (
          <span className="ml-4 pl-3">
            Moy 9AF : <span className="font-italic">{d?.Moy}</span>
          </span>
        )}
        {ph === "nt" && (
          <span className="ml-3">
            Moy 9AF : <span className="display-5">{d?.Moy}</span>
          </span>
        )}
      </h4>

      <div className="text-center h3">
        {(ph === "ph" || ph === "ns3") && (
          <span>
            Moy. 9 A.F : <span className="display-5">{d?.Moy}</span>
          </span>
        )}

        {ph === "ph" &&
          (d?.moyEL > 0 ? (
            <span>
              {" <=> "} Moy. NS2 : <span className="display-5">{d.moyEL}</span>
            </span>
          ) : (
            !d?.moyEL && (
              <div className="h5 text-warning mt-2">
                Info non trouvée en Seconde ou Secondaire II
              </div>
            )
          ))}

        {ph === "ns3" &&
          (d?.moyEL > 0 && d?.moyNs3 > 0 ? (
            <span>
              {" <=> "} Moy. NS2 : <span className="display-5">{d.moyEL}</span>
              {" <=> "} Moy. NS3 : <span className="display-5">{d.moyNs3}</span>
            </span>
          ) : (
            (!d?.moyEL || !d?.moyNs3) && (
              <div className="h5 text-warning mt-2">
                Info non trouvée en NS II / NS-III
              </div>
            )
          ))}
      </div>
    </div>
  );
};

export default DisplayInfoEleve;
